module.exports = "<p>\n  linkpage works!\n</p>\n"